module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-como-08-12.3d294295.jpg";